<ca-conversation-base-list
  [gridId]="gridId"
  [dataSource]="dataSource"
  [gridColumns]="gridColumns"
  (conversationIdChange)="onConversationIdChanged($event)"
  [compactPlayer]="compactPlayer">
</ca-conversation-base-list>
